const apiBaseUrl = import.meta.env.VITE_API_BASE_URL as string | undefined;
const enableEmailCaptureFlag = import.meta.env.VITE_ENABLE_EMAIL_CAPTURE as string | undefined;
const metaPixelId = import.meta.env.VITE_META_PIXEL_ID as string | undefined;
const metaDedupDebugFlag = import.meta.env.VITE_META_DEDUP_DEBUG as string | undefined;
const posthogKey = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const posthogHost = import.meta.env.VITE_POSTHOG_HOST as string | undefined;
const polarTrialPriceDisplay = import.meta.env.VITE_POLAR_TRIAL_PRICE_DISPLAY as string | undefined;
const polarTrialPriceAmount = import.meta.env.VITE_POLAR_TRIAL_PRICE_AMOUNT as string | undefined;
const polarTrialCurrency = import.meta.env.VITE_POLAR_TRIAL_CURRENCY as string | undefined;
const polarTrialDays = import.meta.env.VITE_POLAR_TRIAL_DAYS as string | undefined;
const polarTrialRenewalCopy = import.meta.env.VITE_POLAR_TRIAL_RENEWAL_COPY as string | undefined;
const polarTrialStandardRenewalDisplay = import.meta.env.VITE_POLAR_TRIAL_STANDARD_RENEWAL_DISPLAY as string | undefined;
const polarTrialProRenewalDisplay = import.meta.env.VITE_POLAR_TRIAL_PRO_RENEWAL_DISPLAY as string | undefined;

const parseBooleanFlag = (value: string | undefined, fallback: boolean): boolean => {
  if (!value) return fallback;
  const normalized = value.trim().toLowerCase();
  if (normalized === "true") return true;
  if (normalized === "false") return false;
  return fallback;
};

export const config = {
  apiBaseUrl: apiBaseUrl?.replace(/\/$/, "") ?? "",
  enableEmailCapture: parseBooleanFlag(enableEmailCaptureFlag, true),
  metaPixelId: metaPixelId?.trim() ?? "",
  metaDedupDebug: parseBooleanFlag(metaDedupDebugFlag, false),
  posthogKey: posthogKey?.trim() ?? "",
  posthogHost: posthogHost?.trim() || "https://us.i.posthog.com",
  polarTrialPriceDisplay: polarTrialPriceDisplay?.trim() || "Free",
  polarTrialPriceAmount: polarTrialPriceAmount?.trim() || "0",
  polarTrialCurrency: polarTrialCurrency?.trim() || "AUD",
  polarTrialDays: polarTrialDays?.trim() || "7",
  polarTrialRenewalCopy: polarTrialRenewalCopy?.trim() || "Then renews annually unless canceled.",
  polarTrialStandardRenewalDisplay: polarTrialStandardRenewalDisplay?.trim() || "A$19/year",
  polarTrialProRenewalDisplay: polarTrialProRenewalDisplay?.trim() || "A$29/year",
} as const;

export const brand = {
  name: "Awakeo",
  navbarIconPath: "/assets/brand/navbar-icon-light-bg.webp",
  appIconPath: "/assets/brand/app-icon-dark-bg.webp",
  heroGraphicPath: "/assets/marketing/product UI/v1/hero-product-ui-v3.webp",
  menubarPreviewPath: "/assets/product/product-ui-menubar.webp",
  privacyPolicyUrl: "https://awakeo.app/privacy",
  termsUrl: "https://awakeo.app/terms",
  macosMinimumVersion: "macOS 14+",
} as const;
